module.exports = __webpack_public_path__ + "static/beds-r-us-4e48cc9e69525c824aa7106bb4b08f31.jpg";